import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  categories: [],
  loading: false,
  error: null,
  success: false,
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    // Get all categories
    getCategoriesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getCategoriesSuccess(state, action) {
      state.loading = false;
      state.categories = action.payload;
      state.success = true;
    },
    getCategoriesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    
    // Create category
    createCategoryStart(state) {
      state.loading = true;
      state.error = null;
    },
    createCategorySuccess(state, action) {
      state.loading = false;
      state.categories.push(action.payload);
      state.success = true;
    },
    createCategoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    
    // Update category
    updateCategoryStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateCategorySuccess(state, action) {
      state.loading = false;
      state.categories = state.categories.map(category => 
        category._id === action.payload._id ? action.payload : category
      );
      state.success = true;
    },
    updateCategoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    
    // Delete category
    deleteCategoryStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteCategorySuccess(state, action) {
      state.loading = false;
      state.categories = state.categories.filter(
        category => category._id !== action.payload
      );
      state.success = true;
    },
    deleteCategoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    
    // Reset state
    resetCategoryState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    }
  }
});

export const {
  getCategoriesStart,
  getCategoriesSuccess,
  getCategoriesFailure,
  createCategoryStart,
  createCategorySuccess,
  createCategoryFailure,
  updateCategoryStart,
  updateCategorySuccess,
  updateCategoryFailure,
  deleteCategoryStart,
  deleteCategorySuccess,
  deleteCategoryFailure,
  resetCategoryState
} = categorySlice.actions;

export default categorySlice.reducer;